import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as cryptoJS from 'crypto-js';
import { UserService } from '../services/user.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private toasterService: ToastrService,
    private userService: UserService,
    private translate: TranslateService) {

  }

  // Built per-access so X-LANGUAGE-CODE reflects the language selected at call
  // time, not the one stored when the service was first instantiated.
  get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'X-REQUEST-TYPE': 'web',
        'X-LANGUAGE-CODE': localStorage.getItem('currentLanguage') || 'en'
      })
    };
  }

  login(data: any) {
    const provider = (data.provider === 'NORMAL') ? 'normal' : (data.provider === 'FACEBOOK') ? 'fb' : 'google+';
    const authToken = (data.provider === 'NORMAL') ? '' : data.authToken;
    const socialUserId = (data.provider === 'NORMAL') ? '' : data.id;
    return this.http.post<any>(
      environment.userApiUrl + 'v2/auth/login',
      {
        login_type: provider,
        acesstype: 'web',
        email: data.email,
        password: (data.password) ? data.password : '',
        social_user_id: socialUserId,
        token: authToken,
        name: (data.name) ? data.name : '',
        profile_picture: (data.photoUrl) ? data.photoUrl : ''
      },
      this.httpOptions
    )
      .pipe(map(
        user => {
          if (user['statusCode'] === 200 && user['error'] === false) {
            if (data.provider !== 'NORMAL') {
              user.response.name = data.name;
            }
            const btn = user['response']['access_flag'] ? user['response']['access_flag'] : [];
            localStorage.setItem('userAccessFlag', JSON.stringify(btn));
            const userData = this.encryption(user);
            this.userService.userData(userData);
          }
          return user;
        }
      ));
  }

  async logout(showToaster = true) {
    localStorage.removeItem('userAccessFlag');
    localStorage.removeItem('selectedAccessFlag');
    // 'player-close' doesn't exist in any current template, so this used to throw
    // and abort the rest of logout() (currentUser was never cleared) on every
    // page except a video player. Guard it instead.
    const playerCloseEl = document.getElementById('player-close');
    if (playerCloseEl) {
      playerCloseEl.click();
    }
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.setItem('currentLanguage', 'en');
    await this.userService.userData('');
    await this.router.navigate(['/']);
    if (showToaster) {
      // Previously fired unconditionally regardless of the showToaster argument.
      let getMessage;
      await this.translate.get('LOGOUT.LOGOUT_MESSAGE').subscribe(res => {
        getMessage = res;
        this.toasterService.success('', getMessage);
      });
    }
    this.router.navigate(['/loading']);
  }

  encryption(user) {
    return cryptoJS.AES.encrypt(JSON.stringify(user), environment.encryption_key);
  }

  decryption(data = null) {
    const currentUser = (data === null) ? localStorage.getItem('currentUser') : data;
    let decryptUser: any = {};
    if (currentUser) {
      try {
        const bytes = cryptoJS.AES.decrypt(currentUser.toString(), environment.encryption_key);
        decryptUser = JSON.parse(bytes.toString(cryptoJS.enc.Utf8));
      } catch (e) {
        // Corrupted or stale token (e.g. encrypted with an old key) — clear it
        // instead of throwing, which used to block every API call's headers().
        localStorage.removeItem('currentUser');
        decryptUser = {};
      }
    }
    return decryptUser;
  }
}
